import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const YT_ID = "33swDtHBB2c";

export const VideoStory = () => {
  const [playing, setPlaying] = useState(false);
  const poster = `https://i.ytimg.com/vi/${YT_ID}/maxresdefault.jpg`;
  const posterFallback = `https://i.ytimg.com/vi/${YT_ID}/hqdefault.jpg`;

  return (
    <section id="story" className="bg-ink text-paper py-16 lg:py-24 relative overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative aspect-video w-full overflow-hidden bg-black ring-1 ring-clay/30"
        >
          {!playing ? (
            <button
              onClick={() => setPlaying(true)}
              data-testid="video-play-btn"
              className="group absolute inset-0 w-full h-full flex items-center justify-center"
              aria-label="Play RCCD company video with sound"
            >
              <img
                src={poster}
                onError={(e) => { if (e.currentTarget.src !== posterFallback) e.currentTarget.src = posterFallback; }}
                alt="Get to know RCCD"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.04]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/30 to-ink/45 group-hover:from-ink/70 transition-colors" />

              {/* Center play */}
              <div className="relative z-10 flex flex-col items-center gap-6">
                <div className="relative">
                  <span className="absolute inset-0 rounded-full bg-clay/45 blur-3xl scale-125 group-hover:scale-[1.6] transition-transform duration-700" />
                  <span className="relative flex items-center justify-center h-20 w-20 lg:h-28 lg:w-28 rounded-full bg-paper text-ink ring-1 ring-paper/40 group-hover:bg-clay group-hover:text-paper group-hover:ring-clay transition-colors duration-500">
                    <Play className="h-7 w-7 lg:h-10 lg:w-10 ml-1 fill-current" />
                  </span>
                </div>
              </div>

              {/* Title at bottom — single label, no duplication */}
              <div className="absolute bottom-6 left-6 lg:bottom-10 lg:left-10 right-6 lg:right-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
                <div>
                  <div className="mono text-[10px] uppercase tracking-[0.3em] text-clay">Get to know us</div>
                  <div className="font-display text-2xl lg:text-4xl text-paper mt-2 tracking-[-0.01em]">
                    The RCCD story
                  </div>
                </div>
                <span className="mono text-[10px] uppercase tracking-[0.3em] text-paper/65">
                  Play with sound
                </span>
              </div>
            </button>
          ) : (
            <iframe
              data-testid="video-iframe"
              src={`https://www.youtube-nocookie.com/embed/${YT_ID}?autoplay=1&mute=0&rel=0&modestbranding=1&controls=0&showinfo=0&iv_load_policy=3&disablekb=1&fs=1&playsinline=1`}
              title="Get to know RCCD"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 h-full w-full border-0"
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};
